import { render, staticRenderFns } from "./CreditLineEmployeeSelector.vue?vue&type=template&id=2b4193c0&scoped=true&"
import script from "./CreditLineEmployeeSelector.vue?vue&type=script&lang=js&"
export * from "./CreditLineEmployeeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CreditLineEmployeeSelector.vue?vue&type=style&index=0&id=2b4193c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4193c0",
  null
  
)

export default component.exports